import { render } from "./Fx.vue?vue&type=template&id=734cb1cd"
import script from "./Fx.vue?vue&type=script&lang=js"
export * from "./Fx.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/settings/Fx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "734cb1cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('734cb1cd', __exports__)) {
    api.reload('734cb1cd', __exports__)
  }
  
  module.hot.accept("./Fx.vue?vue&type=template&id=734cb1cd", () => {
    api.rerender('734cb1cd', render)
  })

}


export default __exports__